import { Container, Text, Title, OL, UL, LI } from './contents.styled';

const Privacy = () => (
  <Container>
    <Text>
      Kebijakan Privasi ini mengatur cara Stockbit mengumpulkan, menggunakan,
      memelihara dan mengungkapkan informasi identitas pribadi yang dikumpulkan
      dari pengguna (masing-masing, disebut &quot;Pengguna&quot;) situs web
      Stockbit pada www.Stockbit.com (&quot;Situs&quot;) termasuk Aplikasi
      Seluler Stockbit yang terdaftar di App Store dan Google Play Store, atau
      dikumpulkan melalui layanan jejaring sosial kami (bersama dengan Situs,
      disebut “Layanan”).
    </Text>
    <Text isSecondary>
      This Privacy Policy governs the manner in which Stockbit collects, uses,
      maintains and discloses personally identifiable information collected from
      users (each, a &quot;User&quot;) of the Stockbit website located at
      www.Stockbit.com (&quot;Site&quot;) including Stockbit Mobile App that are
      registered on the App Store and Google Play Store, or collected through
      our social networking service (together with the Site, the “Service”).
    </Text>

    <Text>
      Dengan mengakses dan/atau menggunakan layanan Stockbit, Pengguna
      menyatakan bahwa setiap data Pengguna adalah data yang sah, dan Pengguna
      menyetujui Stockbit untuk memperoleh, mengumpulkan, menyimpan, mengelola
      dan menggunakan data tersebut sebagaimana tercantum dalam Kebijakan
      Privasi dan Syarat dan Ketentuan Stockbit.
    </Text>
    <Text isSecondary>
      By accessing and/or using the Stockbit service, the user declares that
      each user&apos;s data is valid, and the User agrees to Stockbit to obtain,
      collect, store, manage and use the data as stated in the Privacy Policy
      and Stockbit Terms and Conditions.
    </Text>

    <Text>
      Stockbit dari waktu ke waktu berhak memperbarui Kebijakan Privasi ini agar
      tetap relevan dan terkini dengan perubahan teknologi, hukum yang berlaku,
      inovasi Stockbit yang terus berkembang dan kebutuhan Pengguna, dan
      sebaiknya Anda memeriksa halaman ini secara berkala untuk memastikan Anda
      sudah mengetahui perubahan apapun.
    </Text>
    <Text isSecondary>
      Stockbit from time to time has the right to renew this Privacy Policy so
      that it remains relevant and up-to-date with changing technology,
      applicable laws, Stockbit innovations that continue to evolve and User
      needs, and you should check this page periodically to ensure you are
      familiar with any changes.
    </Text>

    <Text>
      Stockbit melindungi semua informasi yang diberikan oleh Pengguna ketika
      Pengguna menggunakan semua Layanan Stockbit.
    </Text>
    <Text isSecondary>
      Stockbit protects all information provided by the User when the User uses
      all the Service.
    </Text>

    <Title id="information-collection">PENGUMPULAN INFORMASI</Title>
    <Title isSecondary>INFORMATION COLLECTION</Title>

    <Text>
      Stockbit mengumpulkan data Pengguna dengan tujuan untuk mengelola dan
      memperlancar proses penggunaan Situs dan/atau Layanan, serta tujuan
      lainnya selama diizinkan oleh peraturan perundang-undangan yang berlaku.
      Data Pengguna yang dikumpulkan adalah sebagai berikut:
    </Text>
    <Text isSecondary>
      Stockbit collects User data with the aim of managing and expediting the
      process of using the Site and/or the Service, as well as other purposes as
      long as permitted by applicable laws and regulations. The User data
      collected is as follows:
    </Text>

    <OL>
      <LI>Informasi tentang Pengguna, termasuk namun tidak terbatas pada:</LI>
    </OL>
    <UL>
      <LI>Nama</LI>
      <LI>Nama Alias (jika ada)</LI>
      <LI>Kebangsaan</LI>
      <LI>Alamat Sesuai KTP/Passport</LI>
      <LI>Alamat Lain (jika ada)</LI>
      <LI>Status pernikahan</LI>
      <LI>Jenis kelamin</LI>
      <LI>Nomor telepon pribadi</LI>
      <LI>E-mail</LI>
      <LI>Tempat dan tanggal lahir</LI>
      <LI>Pekerjaan</LI>
      <LI>Nama ibu kandung</LI>
      <LI>Nomor KTP</LI>
      <LI>Pendapatan rata-rata per tahun</LI>
      <LI>Alamat Kantor (jika ada)</LI>
      <LI>Sumber dana.</LI>
      <LI>ID Pemilik Manfaat (jika ada)</LI>
      <LI>Tujuan pembukaan rekening</LI>
      <LI>Informasi lain (jika diperlukan)</LI>
    </UL>

    <OL isSecondary>
      <LI>Information about User, including but not limited to:</LI>
    </OL>
    <UL isSecondary>
      <LI>Name</LI>
      <LI>Alias name (if any)</LI>
      <LI>Nationality</LI>
      <LI>Address According to ID Card/Passport</LI>
      <LI>Other Address (if any)</LI>
      <LI>Marital status</LI>
      <LI>Gender</LI>
      <LI>Personal phone number</LI>
      <LI>E-mail</LI>
      <LI>Place and date of birth</LI>
      <LI>Occupation</LI>
      <LI>Biological mother&apos;s name</LI>
      <LI>ID card (KTP) number</LI>
      <LI>Average annual income</LI>
      <LI>Office Address (if any)</LI>
      <LI>Source of fund.</LI>
      <LI>Beneficial Owner&rsquo;s ID (if any)</LI>
      <LI>Purpose of opening account</LI>
      <LI>Other information (if needed)</LI>
    </UL>

    <Text>
      Stockbit (PT. Stockbit Sekuritas Digital) menggunakan vendor pihak ketiga
      dalam hal penerapan OCR (Optical Character Recognition) pada kartu
      identitas Pengguna guna mempermudah proses pembukaan rekening. Oleh karena
      itu Pengguna dengan ini setuju untuk memberikan salinan kartu identitasnya
      kepada vendor OCR, terbatas untuk tujuan tersebut.
    </Text>
    <Text isSecondary>
      Stockbit (PT. Stockbit Sekuritas Digital) menggunakan vendor pihak ketiga
      dalam hal menerapkan OCR (Optical Character Recognition) pada KTP Pengguna
      untuk mempermudah proses pembukaan rekening. Oleh karena itu Pengguna
      dengan ini menyetujui untuk membagikan salinan KTP mereka dengan vendor
      OCR, terbatas pada tujuannya.
    </Text>

    <OL start={2}>
      <LI>
        Data yang disampaikan secara mandiri oleh Pengguna. Pengguna harus
        menyampaikan data Pengguna yang akurat, termasuk namun tidak terbatas
        pada data yang disampaikan pada saat Pengguna:
        <OL type="a">
          <LI>
            Membuat atau memperbarui rekening Stockbit, termasuk nama pengguna,
            alamat email, nomor telepon, kata sandi, alamat, foto, dll;
          </LI>
          <LI>Menghubungi Stockbit, termasuk melalui layanan pelanggan;</LI>
          <LI>
            Berinteraksi dengan pengguna lain melalui perpesanan, streaming
            diskusi, ulasan, penilaian, dan sebagainya;
          </LI>
          <LI>
            Menggunakan Layanan pada Stockbit, termasuk rincian data transaksi
            dan/atau tip transaksi pengguna, termasuk jenis, saluran pembayaran
            yang digunakan, tanggal dan waktu transaksi, serta rincian transaksi
            lainnya;
          </LI>
          <LI>
            Menggunakan fitur yang memerlukan izin untuk mengakses perangkat
            Pengguna;
          </LI>
          <LI>
            informasi yang Anda berikan kepada kami selama menggunakan Stockbit
            (termasuk informasi yang terkandung dalam media apapun yang diunggah
            untuk dipublikasikan di Situs atau aplikasi kami); dan
          </LI>
          <LI>
            informasi lain apapun yang Anda pilih untuk dikirimkan kepada kami.
          </LI>
        </OL>
      </LI>
    </OL>
    <OL isSecondary start={2}>
      <LI>
        Data submitted independently by the User. User must submitted the
        accurate User&rsquo;s data, including but not limited to data submitted
        when the User:
      </LI>
      <OL isSecondary type="a">
        <LI>
          Create or renew a Stockbit account, including a username, email
          address, phone number, password, address, photo, etc.;
        </LI>
        <LI>Contact Stockbit, including through customer service;</LI>
        <LI>
          Interacting with other Users through messaging, stream discussion,
          reviews, ratings and so on;
        </LI>
        <LI>
          Use the Service on Stockbit, including detailed transaction data and /
          or tip user transactions, including types, payment channels used, date
          and time of the transaction, as well as other transaction details;
        </LI>
        <LI>
          Use features that require permission to access the User&apos;s device.
        </LI>
        <LI>
          Information that you provide to us in the course of using Stockbit
          (including information contained in any media uploaded for publication
          on our site or App); and
        </LI>
        <LI>any other information that you choose to send to us.</LI>
      </OL>
    </OL>

    <OL start={3}>
      <LI>Data obtained from other sources, including:</LI>
      <OL type="a">
        <LI>Penyedia layanan pemasaran dan notifikasi;</LI>
        <LI>Sumber yang tersedia untuk umum.</LI>
      </OL>
    </OL>
    <OL isSecondary start={3}>
      <LI>Data obtained from other sources, including:</LI>
      <OL isSecondary type="a">
        <LI>Marketing and notification service providers;</LI>
        <LI>Publicly available sources.</LI>
      </OL>
    </OL>

    <OL start={4}>
      <LI>
        Informasi tentang komputer/ponsel Anda dan tentang kunjungan Anda dan
        penggunaan Stockbit (seperti alamat IP Anda, lokasi geografis, jenis
        browser, jenis ponsel, sumber rujukan, lama kunjungan dan jumlah
        tampilan halaman).
      </LI>
    </OL>
    <OL isSecondary start={4}>
      <LI>
        Information about your computer/mobile and about your visits to and use
        of Stockbit (such as your IP address, geographical location, browser
        type, mobile type, referral source, length of visit and number of page
        views).
      </LI>
    </OL>

    <Title id="account-deletion">PENGHAPUSAN REKENING</Title>
    <Title isSecondary>ACCOUNT DELETION</Title>

    <Text>
      Anda dapat meminta untuk menghapus rekening Anda kapan saja. Ketika
      rekening Stockbit Anda dihapus, maka profil, foto, postingan, dan semua
      hal lain yang Anda tambahkan akan dihapus. Anda tidak akan dapat mengambil
      apa pun yang telah Anda tambahkan. Ingatlah bahwa informasi yang dibagikan
      orang lain tentang Anda bukan bagian dari rekening Anda dan tidak akan
      dihapus saat Anda menghapus rekening Anda.
    </Text>

    <OL>
      <LI>Anda tidak akan dapat mengaktifkan kembali rekening Anda.</LI>
      <LI>
        Pengguna dapat menghapus rekening Stockbit dengan mengakses menu: Akun
        &gt; Profil Akun &gt; Hapus Akun.
      </LI>
      <LI>
        Menghapus rekening Stockbit tidak akan menghapus informasi yang
        tercantum di mesin pencari termasuk namun tidak terbatas pada Google
        atau Bing karena Stockbit tidak memiliki kendali atas website tersebut.
      </LI>
      <LI>
        Ketika rekening Stockbit Anda telah dihapus, postingan yang diberi tag
        oleh pengguna lain di profil Anda akan tetap muncul, namun profil Anda
        tidak dapat diakses oleh pengguna lain.
      </LI>
      <LI>
        Bila Anda memilih untuk menghapus rekening Anda, kami akan menghapus
        rekening Anda dari Situs. Beberapa informasi ini dihapus secara permanen
        dari server kami.
      </LI>
      <LI>
        Beberapa informasi, seperti riwayat pesan, tidak disimpan di rekening
        Anda. Artinya, teman Anda mungkin masih memiliki akses ke pesan yang
        Anda kirimkan setelah rekening Anda dihapus.
      </LI>
      <LI>
        Jika Anda ingin menutup rekening perdagangan Anda di PT Stockbit
        Sekuritas Digital, silahkan menghubungi Customer Support kami.
      </LI>
      <LI>
        Pastikan Anda sudah mengosongkan tip jar Anda, karena Stockbit tidak
        bertanggung jawab atas hilangnya tip yang mungkin masih ada di rekening
        Anda.
      </LI>
      <LI>
        Alamat email dan nomor telepon Anda tidak dapat digunakan lagi untuk
        proses pendaftaran selanjutnya.
      </LI>
      <LI>
        Nama pengguna rekening Anda tidak dapat lagi digunakan untuk pendaftaran
        di Stockbit di kemudian hari.
      </LI>
      <LI>
        Jika rekening Anda sudah terverifikasi atau berstatus Admin, maka ketika
        profil Anda dihapus maka status tersebut akan diberhentikan.
      </LI>
      <LI>
        Semua aktivitas berlangganan Anda di Stockbit Pro akan hilang setelah
        penghapusan rekening.
      </LI>
      <LI>
        Salinan beberapa materi mungkin tetap ada di database kami karena
        Stockbit wajib menyimpan informasi dan data terkait rekening Anda sesuai
        peraturan OJK yang berlaku.
      </LI>
      <LI>
        Hubungi tim dukungan pelanggan kami untuk meminta penghapusan data
        permanen dari sistem kami.
      </LI>
    </OL>

    <Text isSecondary>
      You can request to delete your account at any time. When your Stockbit
      account is deleted, your profile, photos, posts, and everything else
      you&apos;ve added will be deleted. You won&apos;t be able to retrieve
      anything you&apos;ve added. Keep in mind that information that others have
      shared about you is not part of your account and will not be deleted when
      you delete your account.
    </Text>

    <OL isSecondary>
      <LI>You won&apos;t be able to reactivate your account.</LI>
      <LI>
        Users can delete their Stockbit account by accessing the menu: Account
        &gt; Public Profile &gt; Delete Account.
      </LI>
      <LI>
        Deleting a Stockbit account will not delete the information listed on
        search engines including but not limited to Google or Bing because
        Stockbit has no control over these websites.
      </LI>
      <LI>
        When your Stockbit account has been deleted, posts tagged by other users
        on your profile will still appear, but your profile cannot be accessed
        by other users.
      </LI>
      <LI>
        When you choose to delete your account, we&apos;ll remove your account
        from the site. Some of this information is permanently deleted from our
        servers.
      </LI>
      <LI>
        Some information, such as messaging history, isn&apos;t stored in your
        account. This means that friends may still have access to messages that
        you sent after your account has been deleted.
      </LI>
      <LI>
        If you want to close your trading account at PT Stockbit Sekuritas
        Digital, please contact our Customer Support.
      </LI>
      <LI>
        Make sure you have emptied your tip jar, because Stockbit will not be
        responsible for any loss of tips that may still be in your Account.
      </LI>
      <LI>
        Your email address and phone number can no longer be used for future
        registration processes.
      </LI>
      <LI>
        Your account username can no longer be used for registration on Stockbit
        in the future.
      </LI>
      <LI>
        If your account is verified or has Admin status, when your profile is
        deleted, the status will be dismissed.
      </LI>
      <LI>
        All of your subscription activity on Stockbit Pro will be lost upon
        account deletion.
      </LI>
      <LI>
        Copies of some material may remain in our database as Stockbit is
        required to keep information and data related to your account according
        to applicable OJK regulations.
      </LI>
      <LI>
        Contact our customer support team to request for permanent data deletion
        from our system.
      </LI>
    </OL>

    <Title id="user-choice-and-transparency">
      PILIHAN PENGGUNA DAN TRANSPARANSI
    </Title>
    <Title isSecondary>USER CHOICE AND TRANSPARENCY</Title>

    <OL>
      <LI>
        Perangkat seluler pada umumnya (iOS, Android, dll) memiliki pengaturan
        sehingga aplikasi Stockbit tidak dapat mengakses data tertentu tanpa
        persetujuan Pengguna. Perangkat iOS akan memberikan notifikasi kepada
        Pengguna saat aplikasi Stockbit pertama kali meminta akses data,
        sedangkan perangkat Android akan memberikan notifikasi kepada Pengguna
        saat aplikasi Stockbit pertama kali dimuat. Dengan menggunakan aplikasi
        dan memberikan akses terhadap aplikasi, Pengguna telah mempertimbangkan
        untuk memberikan persetujuan terhadap Kebijakan Privasi.
      </LI>
    </OL>
    <OL isSecondary>
      <LI>
        Mobile devices in general (iOS, Android, etc.) have settings so that the
        Stockbit application cannot access certain data without the consent of
        the User. The iOS device will give a notification to the User when the
        Stockbit application first requests access to the data, while the
        Android device will give a notification to the User when the Stockbit
        application is first loaded. By using the application and giving access
        to the application, the User has considered giving consent to the
        Privacy Policy.
      </LI>
    </OL>

    <OL start={2}>
      <LI>
        Pengguna dapat mengakses dan mengubah informasi berupa alamat email,
        nomor telepon, tanggal lahir, jenis kelamin, foto profil dan informasi
        lainnya melalui fitur &quot;pengaturan&quot;.
      </LI>
    </OL>
    <OL isSecondary start={2}>
      <LI>
        The User can access and change information in the form of e-mail
        address, telephone number, date of birth, gender, profile photo and
        other information through the &quot;settings&quot; feature.
      </LI>
    </OL>

    <Title id="number-and-contacts-phone">NOMOR DAN KONTAK TELEPON</Title>
    <Title isSecondary>NUMBER AND CONTACTS PHONE</Title>

    <Text>
      Kami tidak akan pernah memindai atau memasukkan kontak Anda kecuali Anda
      memintanya. Jika Anda memilih untuk melakukannya, kami hanya akan
      menggunakan informasi kontak Anda untuk membantu Anda menemukan teman atau
      kontak yang menggunakan Stockbit.
    </Text>
    <Text isSecondary>
      We will never scan or import your contacts unless you ask us to. If you
      choose to do so, we will only use your contact information to help you
      find friends or contacts who use Stockbit.
    </Text>

    <Title id="information-and-disclosure">INFORMASI DAN PENGUNGKAPAN</Title>
    <Title isSecondary>INFORMATION AND DISCLOSURE</Title>

    <Text>
      Selain pengungkapan yang diperlukan secara wajar untuk tujuan yang
      disebutkan di bagian lain dalam Kebijakan Privasi ini, kami dapat
      mengungkapkan informasi tentang Anda:
    </Text>

    <OL>
      <LI>sepanjang kami diharuskan melakukannya oleh hukum;</LI>
      <LI>
        sehubungan dengan proses hukum apa pun atau proses hukum yang prospektif
        (termasuk proses hukum yang direncanakan oleh pihak ketiga, baik
        terhadap kami, Anda, atau pihak ketiga lainnya);
      </LI>
      <LI>
        untuk menetapkan, melaksanakan atau membela hak-hak hukum kami (termasuk
        memberikan informasi kepada orang lain untuk tujuan pencegahan penipuan
        dan mengurangi risiko kredit); dan
      </LI>
      <LI>
        kepada pembeli (atau calon pembeli) bisnis atau aset apa pun yang kami
        (atau rencanakan) jual.
      </LI>
    </OL>

    <Text isSecondary>
      In addition to the disclosures reasonably necessary for the purposes
      identified elsewhere in this privacy policy, we may disclose information
      about you:
    </Text>
    <OL isSecondary>
      <LI>to the extent that we are required to do so by law;</LI>
      <LI>
        in connection with any legal proceedings or prospective legal
        proceedings (including proceedings contemplated by a third party,
        whether against us, you or another third party);
      </LI>
      <LI>
        in order to establish, exercise or defend our legal rights (including
        providing information to others for the purposes of fraud prevention and
        reducing credit risk); and
      </LI>
      <LI>
        to the purchaser (or prospective purchaser) of any business or asset
        which we are (or are contemplating) selling.
      </LI>
    </OL>

    <Title id="underage">DI BAWAH UMUR</Title>
    <Title isSecondary>UNDERAGE (MINOR)</Title>

    <Text>
      Stockbit hanya tersedia bagi setiap orang yang berusia minimal 17 (tujuh
      belas) tahun dan/atau yang secara hukum dianggap mampu membuat kontrak
      yang mengikat.
    </Text>
    <Text isSecondary>
      Stockbit is only available to persons who are at least 17 (seventeen)
      years old and/or who have been legally deemed to be able to form binding
      contracts.
    </Text>

    <Text>
      Apabila kami mengetahui bahwa kami telah mengumpulkan atau menerima data
      pribadi dari anak yang berusia di bawah 17 (tujuh belas) tahun tanpa
      persetujuan orang tua atau wali sah Anda dan/atau anak yang berusia di
      bawah 13 (tiga belas) tahun, maka kami akan menghapus data pribadi
      tersebut. Jika Anda yakin kami mungkin memiliki informasi apa pun dari
      atau tentang anak di bawah 13 (tiga belas) tahun dan/atau anak di bawah 17
      (tujuh belas) tahun tanpa izin, silahkan menghubungi kami di{' '}
      <a href="mailto:Support@stockbit.com">Support@stockbit.com</a>.
    </Text>
    <Text isSecondary>
      If we find out that we have collected or received personal data from a
      child under 17 (seventeen) years of age without the consent of your
      parents or legal guardians and/or a child under 13 (thirteen) years of
      age, we will delete that personal data. If you believe we may have any
      information from or about a child under 13 (thirteen) years and/or a child
      under 17 (seventeen) years without permission, please contact us at{' '}
      <a href="mailto:Support@stockbit.com">Support@stockbit.com</a>.
    </Text>

    <Title id="security">KEAMANAN</Title>
    <Title isSecondary>SECURITY</Title>

    <Text>
      Kami akan mengambil tindakan pencegahan yang wajar untuk mencegah
      kehilangan, penyalahgunaan, atau perubahan informasi pribadi Anda.
    </Text>
    <Text isSecondary>
      We will take reasonable precautions to prevent the loss, misuse, or
      alteration of your personal information.
    </Text>

    <Text>
      Jika Anda memilih untuk mempublikasikan informasi tentang diri Anda di
      profil publik Anda atau dalam artikel yang Anda pilih untuk dipublikasikan
      di Situs (keduanya opsional), informasi ini tentu saja akan tersedia untuk
      umum di internet.
    </Text>
    <Text isSecondary>
      If you choose to publish information about yourself in your public profile
      or in articles you choose to publish on the Site (both optional), this
      information will, of course, be publicly available on the internet.
    </Text>

    <Text>
      Meskipun semua informasi pembayaran dikirim melalui protokol yang aman,
      transmisi data lainnya melalui internet pada dasarnya tidak aman, dan kami
      tidak dapat menjamin keamanan data yang dikirim melalui internet.
    </Text>
    <Text isSecondary>
      While all payment information is sent over a secure protocol, other data
      transmission over the internet is inherently insecure, and we cannot
      guarantee the security of data sent over the internet.
    </Text>

    <Text>
      Anda bertanggung jawab untuk menjaga kerahasiaan kata sandi dan rincian
      Pengguna Anda. Kami tidak akan menanyakan kata sandi Anda (kecuali saat
      Anda login).
    </Text>
    <Text isSecondary>
      You are responsible for keeping your password and User details
      confidential. We will not ask you for your password (except when you log
      in).
    </Text>

    <Title id="third-party-services-websites">
      LAYANAN &amp; SITUS WEB PIHAK KETIGA
    </Title>
    <Title isSecondary>THIRD PARTY SERVICES &amp; WEBSITES</Title>

    <Text>
      Pengguna mungkin akan menemukan iklan atau konten lain di Situs kami yang
      menghubungkan tautan ke situs dan layanan mitra, pemasok, pengiklan,
      sponsor, pemberi lisensi, dan pihak ketiga lainnya. Kami tidak mengontrol
      konten atau tautan yang muncul di situs-situs ini dan tidak bertanggung
      jawab atas praktik yang dilakukan oleh situs-situs yang tertaut ke atau
      dari Situs kami.
    </Text>
    <Text isSecondary>
      Users may find advertising or other content on our Site that links to the
      sites and services of our partners, suppliers, advertisers, sponsors,
      licensors and other third parties. We do not control the content or links
      that appear on these sites and are not responsible for the practices
      employed by websites linked to or from our Site.
    </Text>

    <Text>
      Selain itu, situs atau layanan yang dimaksud di atas, termasuk konten dan
      tautannya, mungkin akan terus berubah. Situs dan layanan tersebut mungkin
      memiliki kebijakan privasi dan kebijakan layanan pelanggannya tersendiri.
      Penjelajahan dan interaksi di situs web lain mana pun, termasuk situs web
      yang memiliki tautan ke Situs kami tunduk pada syarat dan kebijakan situs
      web tersebut.
    </Text>
    <Text isSecondary>
      In addition, these sites or services, including their content and links,
      may be constantly changing. These sites and services may have their own
      privacy policies and customer service policies. Browsing and interaction
      on any other website, including websites which have a link to our Site, is
      subject to that website&apos;s own terms and policies.
    </Text>

    <Text>
      Stockbit Sekuritas Digital juga memiliki kerjasama terkait datafeed dengan
      Bursa Efek Indonesia (BEI). Data yang didapat dari BEI dan sudah mendapat
      persetujuan dari BEI untuk ditampilkan pada aplikasi maupun website
      Stockbit Sekuritas Digital.
    </Text>
    <Text isSecondary>
      Stockbit Sekuritas Digital has a collaboration regarding datafeed with the
      Indonesian Stock Exchange (BEI). Data obtained from the IDX has received
      approval from the IDX to be displayed on the Stockbit Sekuritas Digital
      application and website.
    </Text>

    <Text>
      Dalam menggunakan layanan pihak ketiga apa pun yang tersedia melalui
      Layanan, Anda harus setuju untuk mematuhi dan terikat oleh Ketentuan
      Layanan, Kebijakan Privasi, atau syarat dan ketentuan lain dari penyedia
      layanan pihak ketiga dan mitra pialang kami. Misalnya, ketika mengakses
      layanan broker online yang disediakan oleh PT Stockbit Sekuritas Digital
      (“Stockbit Sekuritas Digital”) melalui Layanan, Syarat dan Ketentuan
      Stockbit Sekuritas Digital berlaku untuk semua masalah yang timbul dari
      penggunaan layanan apa pun yang disediakan kepada Anda melalui Stockbit
      Sekuritas Digital. Syarat dan Ketentuan Stockbit Sekuritas Digital
      tersedia di www.stockbit.com. Oleh karena itu, dengan mengakses Stockbit
      Sekuritas Digital melalui Layanan, Anda mengakui dan menyatakan bahwa Anda
      telah meninjau dan menerima Syarat dan Ketentuan Stockbit Sekuritas
      Digital.
    </Text>
    <Text isSecondary>
      In using any Third-Party Services made available via the Service, you must
      agree to comply with and be bound by the terms of service, privacy policy,
      or other terms and conditions of the third-party service providers and our
      brokerage partners. For example, when accessing online brokerage services
      provided by PT Stockbit Sekuritas Digital (“Stockbit Sekuritas Digital”)
      through the Service, Stockbit Sekuritas Digital&rsquo;s Terms and
      Conditions apply to all issues arising out of the use of any such services
      provided to you through Stockbit Sekuritas Digital. Stockbit Sekuritas
      Digital&rsquo;s Terms and Conditions are available at www.stockbit.com.
      Accordingly, by accessing Stockbit Sekuritas Digital through the Service,
      you acknowledge and represent that you have reviewed and accepted Stockbit
      Sekuritas Digital&rsquo;s Terms and Conditions.
    </Text>

    <Title id="cookies">COOKIES</Title>
    <Title isSecondary>COOKIES</Title>

    <OL>
      <LI>
        Cookies adalah file kecil yang secara otomatis akan disimpan di dalam
        perangkat Pengguna yang menjalankan perangkat dalam bentuk pengelolaan
        istimewa oleh Pengguna selama berada di Situs.
      </LI>
    </OL>
    <OL isSecondary>
      <LI>
        Cookies are small files that will automatically take place inside the
        User device that runs the device in the form of preferentially managing
        the User during the Site.
      </LI>
    </OL>

    <OL start={2}>
      <LI>
        Cookie terdiri dari informasi yang dikirim oleh server web ke browser
        web, dan disimpan oleh browser. Informasi tersebut kemudian dikirim
        kembali ke server setiap kali browser meminta halaman dari server. Hal
        ini memungkinkan server web untuk mengidentifikasi dan melacak browser
        web.
      </LI>
    </OL>
    <OL isSecondary start={2}>
      <LI>
        A cookie consists of information sent by a web server to a web browser,
        and stored by the browser. The information is then sent back to the
        server each time the browser requests a page from the server. This
        enables the web server to identify and track the web browser.
      </LI>
    </OL>

    <OL start={3}>
      <LI>
        Cookies ini tidak dimaksudkan untuk digunakan pada saat mengakses data
        lain yang Pengguna miliki pada perangkat komputer Pengguna, selain dari
        apa yang telah Pengguna setujui untuk disampaikan.
      </LI>
    </OL>
    <OL isSecondary start={3}>
      <LI>
        These cookies are not intended to be used when accessing other data that
        the User has on the User&apos;s computer device, other than what the
        User has agreed to submit.
      </LI>
    </OL>

    <OL start={4}>
      <LI>
        Kami dapat menggunakan cookie &quot;sesi&quot; dan cookie
        &quot;persisten&quot; di situs web. Cookie sesi memungkinkan situs web
        kami melacak Anda saat Anda menavigasi situs web. Cookies yang persisten
        akan memungkinkan situs web kami mengenali komputer Anda ketika Anda
        mengunjungi situs web kami.
      </LI>
    </OL>
    <OL isSecondary start={4}>
      <LI>
        We may use both &quot;session&quot; cookies and &quot;persistent&quot;
        cookies on the website. The session cookies enable our website to keep
        track of you whilst you navigate the website. The persistent cookies
        will enable our website to recognise your computer when you visit our
        website.
      </LI>
    </OL>

    <OL start={5}>
      <LI>
        Meskipun cookie sesi akan dihapus dari komputer Anda saat Anda menutup
        browser, cookie persisten akan tetap tersimpan di komputer Anda hingga
        dihapus, atau hingga mencapai tanggal kedaluwarsa yang ditentukan.
      </LI>
    </OL>
    <OL isSecondary start={5}>
      <LI>
        Whilst session cookies will be deleted from your computer when you close
        your browser, persistent cookies will remain stored on your computer
        until deleted, or until they reach a specified expiry date.
      </LI>
    </OL>

    <OL start={6}>
      <LI>
        Sebagian besar browser mengizinkan Anda menolak menerima cookie.
        (Misalnya, di Internet Explorer Anda dapat menolak semua cookie dengan
        mengklik &quot;Alat&quot;, &quot;Opsi Internet&quot;,
        &quot;Privasi&quot;, dan memilih &quot;Blokir semua cookie&quot;
        menggunakan pemilih geser.) Namun, hal ini akan berdampak negatif pada
        kegunaan banyak situs web, termasuk Situs kami.
      </LI>
    </OL>
    <OL isSecondary start={6}>
      <LI>
        Most browsers allow you to refuse to accept cookies. (For example, in
        Internet Explorer you can refuse all cookies by clicking
        &quot;Tools&quot;, &quot;Internet Options&quot;, &quot;Privacy&quot;,
        and selecting &quot;Block all cookies&quot; using the sliding selector.)
        This will, however, have a negative impact upon the usability of many
        websites, including ours.
      </LI>
    </OL>

    <OL start={7}>
      <LI>
        Stockbit menggunakan fitur Google Analytics Demographics and Interest.
        Data yang kami peroleh dari fitur-fitur ini akan digunakan untuk
        pengembangan Situs dan konten Stockbit. Jika Anda tidak ingin data Anda
        dilacak oleh Google Analytics, Anda dapat menggunakan Google Analytics
        Add-On Browser Opt-Out.
      </LI>
    </OL>
    <OL isSecondary start={7}>
      <LI>
        Stockbit uses the Google Analytics Demographics and Interest feature.
        The data we obtain from these features will be used for the development
        of the Site and Stockbit content. If you don&apos;t want your data to be
        tracked by Google Analytics, you can use the Google Analytics Add-On
        Browser Opt-Out.
      </LI>
    </OL>

    <OL start={8}>
      <LI>
        Stockbit dapat menggunakan fitur-fitur yang disediakan oleh pihak ketiga
        dalam rangka meningkatkan Layanan dan konten Stockbit, termasuk
        penyesuaian dan penyajian iklan kepada setiap Pengguna berdasarkan minat
        atau riwayat kunjungan. Jika Anda tidak ingin iklan Anda ditampilkan
        berdasarkan penyesuaian tersebut, maka Anda dapat mengaturnya melalui
        browser.
      </LI>
    </OL>
    <OL isSecondary start={8}>
      <LI>
        Stockbit may use features provided by third parties in order to improve
        the Service and content of Stockbit, including the adjustment and
        presentation of advertisements to each User based on interest or visit
        history. If you don&apos;t want your ad to be displayed based on these
        adjustments, then you can set it through a browser.
      </LI>
    </OL>

    <Title id="policy-amendments">PERUBAHAN KEBIJAKAN</Title>
    <Title isSecondary>POLICY AMENDMENTS</Title>

    <Text>
      Stockbit dari waktu ke waktu berhak memperbarui Kebijakan Privasi ini agar
      tetap relevan dan terkini dengan perubahan teknologi, hukum yang berlaku,
      inovasi Stockbit yang terus berkembang dan kebutuhan pengguna, dan
      sebaiknya Anda memeriksa halaman ini sesekali untuk memastikan Anda sudah
      mengetahui perubahan apa pun.
    </Text>
    <Text isSecondary>
      Stockbit from time to time has the right to renew this Privacy Policy so
      that it remains relevant and up-to-date with changing technology,
      applicable laws, Stockbit innovations that continue to evolve and user
      needs, and you should check this page occasionally to ensure you are
      familiar with any changes.
    </Text>

    <Title id="contact">KONTAK</Title>
    <Title isSecondary>CONTACT</Title>

    <Text>
      Jika Anda memiliki pertanyaan tentang Kebijakan Privasi ini, praktik situs
      ini, atau perihal lainnya yang berkaitan dengan situs ini, silakan hubungi
      kami di:
    </Text>
    <Text>
      <span>RDTX Square, Lantai 33</span>
      <br />
      <span>Jl. Prof. Dr. Satrio No 164 - Jakarta 12930</span>
      <br />
      <span>Telepon: +62 21 50959330</span>
      <br />
      <span>Whatsapp business: +62 21 50864219</span>
      <br />
      <span>Email: Support@stockbit.com</span>
      <br />
      <span>Jam Operasional: 09:00 - 16.30</span>
    </Text>

    <Text isSecondary>
      If you have any questions about this Privacy Policy, the practices of this
      site, or your dealings with this site, please contact us at:
    </Text>
    <Text isSecondary>
      <em>RDTX Square, 33rd Floor</em>
      <br />
      <em>Jl. Prof. Dr. Satrio No 164 - Jakarta 12930</em>
      <br />
      <em>Phone: +62 21 50959330</em>
      <br />
      <em>Whatsapp business: +62 21 50864219</em>
      <br />
      <em>Email: Support@stockbit.com</em>
      <br />
      <em>Operational hours: 09:00 - 16.30</em>
    </Text>
  </Container>
);

export default Privacy;
